document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-copy-code]');
  if (!button) return;
  try {
    await navigator.clipboard.writeText(button.dataset.copyCode);
    const original = button.dataset.copyLabel || button.textContent;
    button.textContent = button.dataset.copiedLabel || 'Copied';
    window.setTimeout(() => { button.textContent = original; }, 1800);
  } catch (_) {
    button.select?.();
  }
});
